import { render, staticRenderFns } from "./PageBlogDetail.vue?vue&type=template&id=098ab65b&scoped=true&"
import script from "./PageBlogDetail.vue?vue&type=script&lang=js&"
export * from "./PageBlogDetail.vue?vue&type=script&lang=js&"
import style0 from "./PageBlogDetail.vue?vue&type=style&index=0&id=098ab65b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098ab65b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ohid/instaprivat/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('098ab65b')) {
      api.createRecord('098ab65b', component.options)
    } else {
      api.reload('098ab65b', component.options)
    }
    module.hot.accept("./PageBlogDetail.vue?vue&type=template&id=098ab65b&scoped=true&", function () {
      api.rerender('098ab65b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/blog/PageBlogDetail.vue"
export default component.exports